import { FormattedMessage } from "react-intl";
import RecallSelectiveIcon from "../../../components/Common/SvgIcons/DistributeIcons/RecallSelectiveIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { distribute } from "./distribute";
import { recallSelective } from "./recallSelective";

export let recallShotclasses = {
  name: <FormattedMessage id="DISRTIBUTE_RECALLSHOTCLASS" />,
  label: <FormattedMessage id="DISRTIBUTE_RECALLSHOTCLASS" />,
  path: (tenantName) => `/${tenantName}/distribute/recallShotclasses`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: distribute.name,
      path: distribute.path(tenantName),
      onClick: () => navigate(`${distribute.path(tenantName)}`),
    },
    {
      key: 2,
      label: recallShotclasses.label,
      path: `${recallShotclasses.path(tenantName)}`,
      onClick: () => navigate(`${recallShotclasses.path(tenantName)}`),
    },
  ],
  columns: (handleSelectClick, navigate, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="CLASS_NAME_TEXT" />,
      fieldName: "ClassName",
      value: (row) => row.ClassName,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="AFFECTED_USERS" />,
      fieldName: "Count",
      value: (row) => row.Count,
      sort: false,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="RECALL_SELECTIVE" />,
      fieldName: "recall",
      value: (row) => (
        <Tooltip
          direction="bottom"
          content={<FormattedMessage id="CREATE_SELECT_CAT" />}
        >
          <span
            onClick={() => {
              handleSelectClick(row);
              // navigate(recallSelective?.path(tenantName));
            }}
          >
            <RecallSelectiveIcon />
          </span>
        </Tooltip>
      ),
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
};
